import React from 'react'

const Nineteen = () => {
    return (
        <div className='container'>
            <h1>Different Type of Number Pattern</h1>
            <div className='containers'>
            <h3>While Printing Pattern your first task is to find the work done of each row and column</h3>
            <br />
            You will see how to calculate the work done of each row and column in given example
            </div>
      <h3>First we will print the half pyramind pattern</h3>
      <div className='containers'>
      1 <br />
1 2<br />
1 2 3<br />
1 2 3 4<br />
1 2 3 4 5<br />
</div>
<h3>Algorithm to print the pattern</h3>
<ol>
    <li>By seeing the pattern we know that user wants to print pattern till 5th row</li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing number till its nth value like,<br />
    <b>1st column</b>: nth value =1 print 1 <br />
    <b>2nd column</b>: nth value =2 print = 1 2 <br />
    <b>3rd column</b>:nth value =3  print = 1 2 3 <br />
    <b>4th column</b>:nth value =4  print = 1 2 3 4<br />
    <b>5th column</b>:nth value =5  print = 1 2 3 4 5<br />
    now we got the condition for that print the number till we reach to n in each column <br />
    </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
    <li> we will initialize a variable N which takes the input from user </li>
    <li>Then we will intialize a for loop <b>for(int row=1;row &lt;=n ;row++)</b> this will print row till N </li>
    <li>in for loop we will initalize another for loop <b>for(int column=1;column&lt;=row;row++)</b> this will print numbers in each row</li>
 </ol>
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
 <code class="keywords">int</code> main()<br />&#123;<br />
   <code class="keywords">int</code> N;<br />
  <code class="library"> printf</code>("Enter the number of rows: ");<br />
   <code class="library"> scanf</code>("%d", &N);<br />
   <code class="keywords">for</code> (int row = 1;  row &lt;= N; ++row)<br /> &#123;<br />
     <code class="keywords"> for</code> (int column = 1; column &lt;= row; ++column)<br />  &#123;<br />
         <code class="library">printf</code>("%d ", column);<br />
       &#125;<br />
     <code class="library"> printf</code>("\n");<br />
   &#125;
    <code class="library">return</code> 0;<br />
 &#125;<br />
 </div>
 <h3>Inverted half pyramid of numbers</h3>
<div className='containers'>
1 2 3 4 5 <br />
1 2 3 4  <br />
1 2 3 <br />
1 2 <br />
1 <br />
</div>
<h3>Algorithm to print the pattern</h3>
<ol>
    <li>By seeing the pattern we know that user wants to print pattern till 5th row</li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing number in reverse order,<br />
    <b>1st column</b>: nth value =1 print 1 2 3 4 5  <br />
    <b>2nd column</b>: nth value =2 print = 1 2 3 4 <br />
    <b>3rd column</b>:nth value =3  print = 1 2 3 <br />
    <b>4th column</b>:nth value =4  print = 1 2<br />
    <b>5th column</b>:nth value =5  print = 1<br />
    </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
    <li> we will initialize a variable N which takes the input from user </li>
    <li>Then we will intialize a for loop <b>for(int row=N;row &gt;=1 ;--row)</b> this will print row till N </li>
    <li>in for loop we will initalize another for loop <b>for(int column=1;column&gt;=row;++column)</b> this will print numbers in each row</li>
 </ol>
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
 <code class="keywords">int</code> main()<br /> &#123;<br />
   <code class="keywords">int</code> N;<br />
   <code class="library">printf</code>("Enter the number of rows: ");<br />
    <code class="library">scanf</code>("%d", &N);<br />
    <code class="keywords">for</code> (int row = N; row &gt;= 1; --row)<br /> &#123;<br />
      <code class="keywords"> for</code> (int column = 1; column &lt;= row; ++column)<br /> &#123;<br />
         <code class="library"> printf</code>("%d ", column);<br />
      &#125;<br />
       <code class="library">printf</code>("\n");<br />
   &#125;<br />
    <code class="library">return</code> 0;<br />
&#125;

 </div>
 <h3> Full Pyramid of Numbers</h3>
 <div className='containers'>
 &nbsp; &nbsp;   &nbsp;   &nbsp; {' '} 1 <br />
           
     &nbsp;  &nbsp; &nbsp; 2 3 2<br />
   &nbsp; &nbsp;3 4 5 4 3<br />
 &nbsp;  4 5 6 7 6 5 4<br />
5 6 7 8 9 8 7 6 5<br />
 </div>
<h3>Algorithm to print the pattern </h3>
<ol>
    <li>By seeing the pattern we know that user wants to print pattern till 5th row</li>
    <li>So,Now first we have to calculate the work done of each column,<br />So by each column
    we observed that each column is printing number from row number to row to number,<br />
    <b>1st column</b>: nth value =1 print 1   <br />
    <b>2nd column</b>: nth value =2 print = 2 3 2 <br />
    <b>3rd column</b>:nth value =3  print = 3 4 5 4 3 <br />
    <b>4th column</b>:nth value =4  print = 4 5 6 7 6 5 4<br />
    <b>5th column</b>:nth value =5  print =5 6 7 8 9 8 7 6 5<br />
    </li>
    <li>in this type of pattern you have to focus on spaces also that how the spaces are printing</li>
    <li>You will observe that till in each column number is increasing till middle after they start to decrease till row number </li>
    <li> Now we we wll calculate for  row ,<br /> so by observing row we get that we have to print row till n.</li>
    <li> we will initialize a variable N which takes the input from user </li>
    <li>Then we will intialize a for loop <b>for(int row=N;row &gt;=1 ;--row)</b> this will print row till N </li>
    <li>in for loop we will initalize another for loop <b>for(int column=1;column&gt;=row;++column)</b> this will print numbers in each row</li>
 </ol>
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
 <code class="keywords">int </code>main() &#123;<br />
 <code class="keywords"> int </code>N, space, rows, column = 0, count = 0, count1 = 0;<br />
 <code class="library"> printf</code>("Enter the number of rows: ");<br />
 <code class="library"> scanf</code>("%d", &N);<br />
 <code class="keywords"> for </code>(int row = 1; row &lt;= N; ++row) &#123;<br />
 <code class="keywords">   for</code> (int space = 1;  space &lt;= N - row; ++space) &#123;<br />
 <code class="library">   printf</code>("  ");<br />
         ++count;<br />
      &#125;<br />
      <code class="keywords"> while</code> (column != 2 * row - 1) &#123;<br />
      <code class="keywords">  if</code> (count &lt;= N - 1) &#123;<br />
      <code class="library">     printf</code>("%d ", row + column);<br />
            ++count;<br />
         &#125; <code class="keywords">else</code> &#123;<br />
            ++count1;<br />
            <code class="library">  printf</code>("%d ", (row + column - 2 * count1));<br />
         &#125;<br />
         ++column;<br />
      &#125;<br />
      count1 = count = column = 0;<br />
      <code class="library"> printf</code>("\n");<br />
   &#125;<br />
   <code class="library"> return</code> 0;<br />
&#125;<br />
 </div>
 <h3>Pascal triangle</h3>
 <div className='containers'>
 &nbsp; &nbsp;   &nbsp;   &nbsp;1 <br />
 &nbsp; &nbsp;   &nbsp;           1 &nbsp;  1<br />
 &nbsp; &nbsp;        1  &nbsp; 2 &nbsp;  1<br />
 &nbsp;     1  &nbsp; 3 &nbsp;  3  &nbsp;  1<br />
   1 &nbsp; 4   &nbsp; 6&nbsp;   4 &nbsp;  1<br />
 </div><br />
 <div className='containers'>
 <code class="library">#include &lt;stdio.h&gt;</code> <br />
<code class="keywords">int</code> main() &#123;<br />
   <code class="keywords">int</code> N, coef = 1;<br />
   <code class="library">printf</code>("Enter the number of N: ");<br />
   <code class="library"> scanf</code>("%d", &N);<br />
   <code class="keywords">for </code>( int row = 0; row &lt; N; row++) &#123;<br />
   <code class="keywords">for</code> (int space = 1; space &lt;= N - row; space++)<br />
   <code class="library"> printf</code>("  ");<br />
   <code class="keywords">for</code> (int column = 0; column &lt;= row; column++) &#123;<br />
   <code class="keywords">if</code> (column == 0 || row == 0)<br />
            coef = 1;<br />
            <code class="keywords">   else</code><br />
            coef = coef * (row - column + 1) / column;<br />
            <code class="library">   printf</code>("%4d", coef);<br />
      &#125;<br />
      <code class="library">  printf</code>("\n");<br />
   &#125;<br />
   <code class="library">  return</code> 0;<br />
&#125;<br />
 </div>
 
        </div>
    )
}

export default Nineteen
